import {OfferingFormPriceType} from "@/features/pricing";
import {Currency} from "../../../calls/useCases/createService/types";
import {DigitalProductCurrencyInput} from "../../../features/digital-products";

/** The pricing slice of the Digital Product form — all this translation reads. */
type DigitalProductPricingFormValues = {
  priceType: OfferingFormPriceType;
  currencies: Currency[];
  selected_currencies?: string[];
};

type DigitalProductPricingInput = {
  currencies: DigitalProductCurrencyInput[];
  isPayWhatYouWant: boolean;
  enableCurrencyConversion: boolean;
  selectedCurrencies: string[];
};

/**
 * The Digital Product leg of the Pricing Model translation, shared by the create wizard
 * and the edit page.
 *
 * Digital Products put EVERY currency row into `currencies[]`, base row included, and
 * have no base-level Minimum Price — unlike live events and booking services, which split
 * the base row into top-level scalars. See
 * `docs/adr/0002-pricing-slice-uniform-currency-rows.md`.
 *
 * Free is priced as a single zero row, the way it always has been. Single Fee sends the
 * amounts but no Minimum Price, so a minimum the coach typed during a visit to Pay What
 * You Want cannot leak out under a model that has no meaning for it.
 */
export function toDigitalProductPricingInput(
  values: DigitalProductPricingFormValues
): DigitalProductPricingInput {
  const isPayWhatYouWant = values.priceType === "pwyw";

  return {
    isPayWhatYouWant,
    currencies:
      values.priceType === "free"
        ? [{callPriceCurrency: "NGN", callPrice: 0}]
        : values.currencies.map((currency) => ({
            callPriceCurrency: currency.callPriceCurrency,
            callPrice: currency.callPrice,
            ...(isPayWhatYouWant ? {minCallPrice: currency.minCallPrice} : {}),
          })),
    enableCurrencyConversion: values.priceType !== "free",
    selectedCurrencies:
      values.priceType === "free" ? [] : values.selected_currencies ?? [],
  };
}
